const MY_ACCOUNTS_PATH = '/accounts/my-accounts'
const ALL_ACCOUNTS_PATH = '/accounts/all-accounts'
export const KEAP_SANDBOX_PATH = '/accounts/keap-sandbox'
const HIDE_ALL_ACCOUNTS_FOR_RESELLER = true
const HIDE_MY_ACCOUNTS_FOR_TSS = true

export const ACCOUNT_TABS = [
  {label: 'My Accounts', path: MY_ACCOUNTS_PATH},
  {label: 'All Accounts', path: ALL_ACCOUNTS_PATH},
]

const toRoleList = roles =>
  Array.isArray(roles) ? roles : roles ? [roles] : []

export const hasResellerRole = roles =>
  toRoleList(roles).some(role => String(role).toLowerCase() === 'reseller')

export const hasTSSRole = roles =>
  toRoleList(roles).some(role => String(role).toLowerCase() === 'tss')

// Roles whose reps already have a fixed/known partner-channel attribution — clicking
// Create Purchase Link for these roles skips straight to ordering. Every other role sees
// the Edit Location/Account details modal first so they can review/complete the location's
// info before a purchase link is generated.
const SKIP_ORDER_EDIT_MODAL_ROLES = [
  'KeapPartner',
  'Reseller',
  'InfluencerOps',
  'PartnerOps',
]

export const shouldSkipOrderEditModal = roles => {
  const normalizedRoles = new Set(
    toRoleList(roles).map(role => String(role).toLowerCase()),
  )
  return SKIP_ORDER_EDIT_MODAL_ROLES.some(role =>
    normalizedRoles.has(role.toLowerCase()),
  )
}

export const hasPartnerOpsRole = roles =>
  toRoleList(roles).some(role => String(role).toLowerCase() === 'partnerops')

export const hasInfluencerOpsRole = roles =>
  toRoleList(roles).some(role => String(role).toLowerCase() === 'influencerops')

// PartnerOps uses the shared Purchase Link wizard (Catalog Selection →
// Scheduling → Payment Details) like every other role. The old catalog.js →
// payment-details.js → partner-ops/generate-link pipeline stays reachable only
// as an operational rollback, behind the same env flag AccountInfo.js already
// uses for the legacy KP11 catalog.
export const isLegacyKeapCatalogEnabled = () =>
  process.env.REACT_APP_ENABLE_LEGACY_KP_CATALOG === 'true'

export const shouldUseLegacyPartnerOpsFlow = roles =>
  isLegacyKeapCatalogEnabled() && hasPartnerOpsRole(roles)

const shouldHideAllAccounts = roles =>
  HIDE_ALL_ACCOUNTS_FOR_RESELLER && hasResellerRole(roles)

const shouldHideMyAccounts = roles =>
  HIDE_MY_ACCOUNTS_FOR_TSS && hasTSSRole(roles)

const pathMatches = (pathname, path) =>
  pathname === path || pathname.startsWith(`${path}/`)

export const getAccountTabs = (roles, features = {}) => {
  let tabs = [...ACCOUNT_TABS]
  if (shouldHideAllAccounts(roles))
    tabs = tabs.filter(tab => tab.path !== ALL_ACCOUNTS_PATH)
  if (shouldHideMyAccounts(roles))
    tabs = tabs.filter(tab => tab.path !== MY_ACCOUNTS_PATH)
  if (features.Keap_Sandbox_Access)
    tabs.push({label: 'Keap Sandbox', path: KEAP_SANDBOX_PATH})
  return tabs
}

export const getAccountManagementLandingPath = roles =>
  shouldHideMyAccounts(roles) ? ALL_ACCOUNTS_PATH : MY_ACCOUNTS_PATH

export const isAccountPathHiddenForRoles = (pathname, roles) =>
  (shouldHideAllAccounts(roles) &&
    (pathMatches(pathname, ALL_ACCOUNTS_PATH) ||
      pathMatches(pathname, '/all-accounts'))) ||
  (shouldHideMyAccounts(roles) &&
    (pathMatches(pathname, MY_ACCOUNTS_PATH) ||
      pathMatches(pathname, '/my-accounts')))
